import React from 'react';
import { cn } from '@/lib/utils';

interface DropIndicatorProps {
  isVisible: boolean;
  position: 'above' | 'below';
}

const DropIndicator: React.FC<DropIndicatorProps> = ({ isVisible, position }) => {
  if (!isVisible) return null;

  return (
    <div 
      className={cn(
        "absolute left-0 right-0 z-40 flex items-center",
        position === 'above' ? '-top-1' : '-bottom-1'
      )}
    >
      <div className="h-0.5 bg-primary rounded-full flex-1 shadow-lg animate-pulse">
        <div className="h-full bg-gradient-to-r from-primary/50 via-primary to-primary/50 rounded-full"></div>
      </div>
      <div className="w-2 h-2 bg-primary rounded-full ml-1 shadow-lg animate-pulse"></div>
    </div>
  );
};

export default DropIndicator;